module.exports = __webpack_public_path__ + "img/icon-shanchu.a98e0efb.svg";